﻿(function () {

    'use strict';
    var serviceId = 'repository.equipmentdamage';
    angular
        .module('app.services')
        .factory(serviceId, equipmentdamage);

    equipmentdamage.$inject = ['common', 'repository.abstract', '$http'];

    function equipmentdamage(common, abstractRepository, $http) {
        var config = common.config;
        function Ctor(mgr) {
            this.manager = mgr;
            this.getEquipmentsByNo = getEquipmentsByNo;
            this.getEquipmentDamageByCriteria = getEquipmentDamageByCriteria;
        }

        abstractRepository.extend(Ctor);
        return Ctor;

        function getEquipmentsByNo(criterio) {            
            var authData = common.localStorageService.get('authorizationData');
            return common.httpGet(config.basePaths.Base_Path_Resources + 'equipment/GetEquipmentsByNoByUser?criteria=' + criterio + '&usuario=' + (authData ? authData.userRole : "") + '&isOnlyPortalUser=' + (authData ? authData.isOnlyPortalUser : false));
        }

        function getEquipmentDamageByCriteria(model) {                        
            var authData = common.localStorageService.get('authorizationData');
            return common.httpGet(config.basePaths.Base_Path_Resources + 'mrinspection/GetInspectionsFromEquipment?equipmentNo=' + model.EquipmentNo + '&role=' + (authData ? authData.userRole : "") + '&isOnlyPortalUser=' + (authData ? authData.isOnlyPortalUser : false));
        }

    }

})();
